import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: ReactNode;
  className?: string;
  animate?: boolean;
  delay?: number;
}

export function Card({ children, className = '', animate = true, delay = 0 }: CardProps) {
  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay }}
        className={`glass-card rounded-2xl p-5 ${className}`}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div className={`glass-card rounded-2xl p-5 ${className}`}>
      {children}
    </div>
  );
}
